<template>
  <div
    data-cy="list-link"
    v-if="list"
    :class="currentList && list.id == currentList.id ? 'dwp-bg-gray-200 dwp-mr-6' : 'dwp-bg-white-200'"
    class="dwp-px-8 dwp-flex dwp-items-center dwp-justify-between dwp-py-2 dwp-text-sm dwp-cursor-pointer dwp-rounded-r-full"
  >
    <span
      class="dwp-flex-shrink dwp-flex dwp-items-center dwp-space-x-2 dwp-truncate dwp-text-gray-800"
    >
      <ProgressBadge
        :percentage="percentage(list)"
        class="dwp-rounded-full dwp-w-4 dwp-h-4 dwp-duration-500 dwp-flex-shrink-0"
        :class="percentage(list) == 100 ? 'dwp-text-green-500 dwp-border-green-500' : 'dwp-text-primary dwp-border-primary'"
        style="border-width: 1.5px; padding: 2px; transition-property:border-color"
      />
      <div class="dwp-flex-1 dwp-truncate">{{ list.title }}</div>
    </span>
    <slot />
  </div>
</template>

<script>
import currentList from "@/mixins/current-list";
import ProgressBadge from "@/components/ui/ProgressBadge.vue";

export default {
  mixins: [currentList],

  components: {
    ProgressBadge,
  },

  props: {
    list: Object,
  },

  methods: {
    percentage(list) {
      if (!list?.counts?.total || !list?.counts?.done) {
        return 0;
      }
      return (list.counts.done / list.counts.total) * 100;
    },
  },
};
</script>